import { render, staticRenderFns } from "./lxexplain.vue?vue&type=template&id=4726a9e8&scoped=true&"
import script from "./lxexplain.vue?vue&type=script&lang=js&"
export * from "./lxexplain.vue?vue&type=script&lang=js&"
import style0 from "./lxexplain.vue?vue&type=style&index=0&id=4726a9e8&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4726a9e8",
  null
  
)

export default component.exports